import { MANAGER_ACL } from 'constants/acl'
export const managerCan = (required, roleName) => {
  const acl = MANAGER_ACL[roleName]
  return acl >= required
}
